import React from 'react';
import { Alert } from '../../../../../../base/components/Alert';
import { Button } from '../../../../../../base/components/Button';
import { PhoneInput } from '../../../../../../base/components/Forms/PhoneInput';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';

import '../styles.scss';

export const SetNewLogin = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone },
        errors,
    } = useAppSelector((state) => state.workerAppSettings.changeLogin);
    const { phoneInputConfig } = useAppSelector((state) => state.workerApp.config);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(settingsActions.setChangeLoginField({ id, value }));
    };

    const submitSetNewPasswordHandler = () => dispatch(settingsActions.changeLoginSubmit());

    return (
        <div className='change-login'>
            <Alert
                text={__t(
                    'Новый номер телефона будет использоваться для входа на сайт, а также виден работодателю для контакта с вами.',
                )}
                type='warn'
                icon='circle-exclamation-regular'
                className='change-login__alert'
            />
            <div className='change-login__form-item scroll-margin-for-fixed-header'>
                <p className='change-login__form-label'>{__t('Новый номер телефона')}</p>
                <PhoneInput
                    value={phone}
                    onChange={(value: string) => inputChangeHandler('phone', value)}
                    errors={errors?.phone}
                    onlyCountries={phoneInputConfig.countries}
                    preferredCountries={phoneInputConfig.preferredCountries}
                    localization={phoneInputConfig.localization}
                />
            </div>
            <Button className='change-login__button' onClick={submitSetNewPasswordHandler}>
                {__t('Сохранить')}
            </Button>
        </div>
    );
};
